import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { Form, TextInput } from '../../UI'

import { validateEmail } from '../../../libs/validation'

import { translate } from 'react-i18next'
import { NotificationManager } from 'react-notifications'

import UPDATE_PAYPAL_EMAIL from './../../../graphql/Profile/UpdateUserProfile.graphql'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

import Loader from '../../UI/Loader'

class PayPal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      saving: false,
      routeIndex: 11
    }
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState(() => ({
      saving: true
    }))
    this.props
      .updateProfile({
        variables: {
          id: this.props.data.User.userProfile.id,
          payPalEmail: values.payPalEmail
        }
      })
      .then(() => {
        this.props.data.refetch()
        NotificationManager.success('Payment updated', 'Success', 5000)
        this.setState({ saved: true, saving: false }, () => {
          this.props.history.push('/create-guru-profile/example-plan')
        })
      })
      .catch(err => {
        this.setState(() => ({
          saving: true
        }))
        NotificationManager.error('Error while updating payment', 'Error', 5000)
      })
  }

  render() {
    const { t } = this.props

    if (this.props.loading) {
      return <Loader showLoader={true} />
    }

    const email = this.props.data && this.props.data.User ? this.props.data.User.userProfile.payPalEmail : ''

    const { saving } = this.state
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">PayPal</div>

        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div className="steps-screen__form-subtitle">{t('pay_pal_description')}</div>
            <div className="form-input-example">{t('pal_pal_description_example')}</div>
            <TextInput
              id="payPalEmail"
              placeholder={t('short_description_placeholder')}
              initialValue={email}
              validationFuncs={[validateEmail]}
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('guru'),
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  graphql(UPDATE_PAYPAL_EMAIL, {
    name: 'updateProfile'
  }),
  withRouter
)
export default enhance(PayPal)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/PayPal.js